import { MenuItem } from '@mui/material';
import styled from '@emotion/styled';

export const StyledMenuItem = styled(MenuItem)`
  padding: 3px 10px;
  width: 100%;
`;
